//mapped type to cureted category
export const SERVICE = 'service';
export const PRODUCT = 'product';
export const STAFF = 'staff';
export const OTHERS = 'others';

//entity types
export const CATEGORY = 'category';
export const ITEMS = 'items';
export const IMAGES = 'images';